module.exports = __webpack_public_path__ + "static/aboutPage-ee71241d7185b22f4159de6ef106497d.png";